"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSolarPower = function IconSolarPower(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m35.324 4.417-2-2-.707.707 2 2zm1.802 1.965-1.271-1.544-.177.152a5 5 0 1 0 7.064 7.06l-1.484-1.34-.137.142a3 3 0 1 1-3.995-4.47M39 18.97v-4h-1v4zm-6-11v1h-4v-1zm2.324 5.154-.707-.708-2 2 .707.708zm8-.708 2 2-.707.708-2-2zM10.856 20.97h26.242l2.414 17H27v3h3v2H18v-2h3v-3H8.748zM22 40.97h4v-3h-4zm13.929-14-.568-4h-7.276l.25 4zm-8.596 0-.25-4h-6.186l-.25 4zm-6.748 1h6.81l.25 4h-7.31zm-.312 5h7.434l.187 3h-7.808zm8.436 0 .187 3h8.311l-.426-3zm-.312-5 .25 4h7.992l-.568-4zm-8.752-1h-7.518l.496-4h7.272zm-.062 1-.25 4h-7.826l.496-4zm-.312 5h-7.888l-.372 3h8.073z",
    clipRule: "evenodd"
  })));
};

export { IconSolarPower, IconSolarPower as default };
